<template>
  <div>
    <Can I="delete" a="/uye/Uye">
        <b-modal
        id="modal-uye-delete"
        centered
        title="Üye Sil"
        ok-title="Sil"
        ok-variant="danger"
        header-bg-variant="danger"
        header-text-variant="white"
        cancel-title="İptal"
        cancel-variant="outline-secondary"
        @ok.prevent="remove"
        :busy="overlay"
        >
            <p>{{ getMessage(331) }}</p>
        </b-modal>
    </Can>
    <Can I="read" a="/uye/UyeLog">
      <b-modal
        id="modal-log"
        size="lg"
        centered
        title="Loglar"
        ok-variant="secondary"
        ok-title="Kapat"
        ok-only
        :busy="$store.state.general.showOverlay"
        @hidden="clearLogForm">
        <div>
          <form>
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group">
                    <label>Uye Adı</label>
                    <input type="text" class="form-control" v-model="logForm.parameter1" maxlength="128">
                </div>
              </div>
              <div class="col-sm-5">
                <div class="form-group">
                    <label>Kullanıcı Adı</label>
                    <input type="text" class="form-control" v-model="logForm.userName" maxlength="64">
                </div>
              </div>
              <div class="col-sm-2">
                <button class="btn btn-block btn-outline-secondary mt-4" type="button" @click="getLogModal">Listele</button>
              </div>
            </div>
          </form>
          <div class="table-responsive" style="max-height:500px;">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>İşlem Tarihi</th>
                  <th class="fit">Eser Id</th>
                  <th class="fit">İşlem</th>
                  <th class="fit">Kolon Adı</th>
                  <th class="fit">Tablo Adı</th>
                  <th>Eski Değer</th>
                  <th>Yeni Değer</th>
                  <th class="fit">Kullanıcı Adı</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in log.liste" :key="index"  class="cursor-pointer">
                  <td>{{ item.modTime | moment("DD/MM/YYYY") }}</td>
                  <td class="fit">{{ item.eserID }}</td>
                  <td class="fit">{{ getLogAction(item.action) }}</td>
                  <td class="fit">{{ item.columnName }}</td>
                  <td class="fit">{{ item.tableName }}</td>
                  <td>{{ item.oldValue }}</td>
                  <td>{{ item.newValue }}</td>
                  <td class="fit">{{ item.userName }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="alert alert-danger text-center" v-if="showError">{{ errorMessage }}</div>
          <div class="row" v-if="log.liste.length > 0">
            <div class="col">
              <i class="text-secondary">{{ log.sayfalama.totalItems }} kayıttan {{ ((logForm.pageNum - 1) * logForm.pageSize) + 1 }} - {{ logForm.pageNum * logForm.pageSize }} arası gösterilmektedir</i>
            </div>
            <div class="col">
              <div class="row">
                <div class="col d-flex justify-content-end">
                  <nav>
                    <paginate v-if="log.liste.length"
                              :page-count="log.sayfalama.totalPages"
                              :click-handler="changeLogPage"
                              :prev-text="'Önceki'"
                              :next-text="'Sonraki'"
                              :active-class="'active'"
                              :container-class="'pagination'"
                              v-model="logForm.pageNum">
                    </paginate>
                  </nav>
                </div>
                <div class="col-2">
                  <select v-select class="form-control" v-model="logForm.pageSize" @change="changeLogSize">
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </Can>
    <b-modal
      id="modal-file-upload"
      size="lg"
      centered
      title="Toplu Üye Yükleme"
      ok-variant="secondary"
      ok-title="Kapat"
      ok-only
      :busy="$store.state.general.showOverlay"
      @hidden="$store.state.general.showPopup=false"
    >
      <div>
        <form>
          <div class="row">
            <div class="col-12" style="text-align:center;">
              <a :href="getFileLink('UyeTopluYuklemeTaslakDosyası')">Taslak Excel dosyasını indirme için tıklayınız.</a>
              <br /><br />
            </div>
            <div class="col-9">
              <div class="form-group">
                <input type="text" class="form-control" disabled v-model="fileUploadForm.fileName"
                      :class="{ 'is-invalid': $v.fileUploadForm.fileName.$error }">
                <template v-if="$v.fileUploadForm.fileName.$error">
                  <small class="text-danger" v-if="!$v.fileUploadForm.fileName.requiredIf">{{ getMessage(162) }}</small>
                </template>
              </div>
            </div>
            <div class="col-3">
              <input type="file" ref="file" class="d-none" @change="onChangeFileUpload()">
              <button type="button" class="btn btn-secondary w-100" @click="$refs.file.click()">Doküman Seç</button>
            </div>
            <div class="modal-cutom-footer" v-if="fileUploadForm.fileName != ''">
              <Can I="create" a="/meslek-birligi/MBPersonel">
                <button type="button" class="btn btn-success" style="margin-right" @click="fileUploader(true)" :disabled="$store.state.general.showOverlay">Dosyayı Kontrol Et</button>
                <button type="button" class="btn btn-success" @click="fileUploader(false)" :disabled="$store.state.general.showOverlay">Dosyayı Yükle</button>
              </Can>
            </div>
          </div>
        </form>
      </div>
    </b-modal>
    <div class="standart-page">
      <div class="row">
        <div class="col"></div>
        <div class="col"><h3 class="title">ÜYELER</h3></div>
        <div class="col d-flex justify-content-end align-items-start">
          <Can I="create" a="/uye/Uye">
            <button class="btn btn-danger" @click="$router.push('uye/detay')"><font-awesome-icon icon="plus" size="lg"></font-awesome-icon> Yeni Üye</button>
          </Can>
        </div>
      </div>
      <div class="card-component mb-5">
        <div class="body">
          <div class="row">
            <div class="col-sm-3">
              <div class="form-group">
                <label>Meslek Birliği Üye ID</label>
                <input type="text" class="form-control" v-model="form.mbMemberId">
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>Ad Soyad</label>
                <input type="text" class="form-control" v-model="form.adSoyad" maxlength="128">
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label>TC Kimlik No</label>
                <input type="text" class="form-control" v-mask="'###########'" v-model="form.tcKimlikNo">
              </div>
            </div>

            <div class="col-sm-3">
              <div class="form-group">
                <label>Üyelik Başlangıç Tarihi</label>
                <date-picker v-model="form.uyelikTarihiBaslangicUI" format="DD.MM.YYYY" valueType="format"></date-picker>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label>Üyelik Bitiş Tarihi</label>
                <date-picker v-model="form.uyelikTarihiBitisUI" format="DD.MM.YYYY" valueType="format"></date-picker>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label>Yetki Belgesi Başlangıç Tarihi</label>
                <date-picker v-model="form.yetkiBelgesiBaslangicUI" format="DD.MM.YYYY" valueType="format"></date-picker>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label>Yetki Belgesi Bitiş Tarihi</label>
                <date-picker v-model="form.yetkiBelgesiBitisUI" format="DD.MM.YYYY" valueType="format"></date-picker>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label>Üyelik Türü</label>
                <select v-select class="form-control" v-model="form.uyelikTuru" v-if="$store.state.auth.user.mbId !== 0">
                    <option :value="0">Seçiniz</option>
                    <option :value="item.uyeTurId"
                            v-for="(item,index) in uyelikTurListe" :key="index">
                            {{ getOptionWithParams(item.uyeTurId, "uyelikTur") }}
                    </option>
                </select>
                <select v-select class="form-control" v-model="form.uyelikTuru" v-if="$store.state.auth.user.mbId === 0">
                    <option :value="0">Seçiniz</option>
                    <option :value="item.id" v-for="(item,index) in $store.state.general.parameters.uyelikTur" :key="index">
                      {{ item.name }}
                    </option>
                </select>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label>Üyelik Durumu</label>
                <select v-select class="form-control" v-model="form.uyelikDurumu">
                    <option value="">Seçiniz</option>
                    <option :value="item.id"
                            v-for="(item,index) in $store.state.general.parameters.uyelikDurumu" :key="index">
                            {{ item.name }}
                    </option>
                </select>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label>Sıralama Kriteri</label>
                <select v-select class="form-control" v-model="form.orderType">
                    <option value="0">Seçiniz</option>
                    <option :value="item.id"
                            v-for="(item,index) in $store.state.general.parameters.uyeSearchOrderType" :key="index">
                            {{ item.name }}
                    </option>
                </select>
              </div>
            </div>
            <div class="col-sm-3" v-if="$store.state.auth.user.mbId === 0">
              <div class="form-group">
                <label>Meslek Birliği</label>
                <select v-select class="form-control" v-model="form.mbId">
                  <option :value="0">Seçiniz</option>
                  <option :value="item.id"
                      v-for="(item,index) in mblist"
                      :key="index">
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="footer d-flex justify-content-end">
          <Can I="read" a="/uye/UyeLog">
            <button class="btn btn-outline-secondary mt-4" v-b-modal.modal-log>Log</button>
          </Can>
          <Can I="create" a="/uye/UyeTopluYukleme">
            <button class="btn btn-outline-primary mt-4" @click="addFileUploadModal">Toplu Üye Yükleme</button>
          </Can>
          <button class="btn btn-outline-secondary mt-4" @click="clear">Temizle</button>
          <button class="btn btn-secondary mt-4" @click="search">Listele</button>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Adı Soyadı / Unvan</th>
              <th class="fit">T.C. / Vergi No</th>
              <th class="fit">Yetki Belgesi Tarihi</th>
              <th class="fit">E-Posta</th>
              <th class="fit">Telefon</th>
              <th class="fit" v-if="$store.state.auth.user.mbId === 0">Meslek Birliği</th>
              <th class="fit text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in $store.state.uye.uye.liste" :key="index" class="cursor-pointer" @click="$router.push('/uye/detay/' + item.recordId)">
              <td>{{ item.adiSoyadiUnvani }}</td>
              <td class="fit">
                <span v-if="item.tcKimlikNo">{{item.tcKimlikNo}}</span>
                <span v-if="item.tcKimlikNo && item.vergiNo"> / </span>
                <span v-if="item.vergiNo">{{item.vergiNo}}</span>
              </td>
              <td class="fit">{{ item.yetkiBelgesiGecerlilikSonTarihi | moment("DD/MM/YYYY") }}</td>
              <td class="fit">{{item.iletisim_EMail}}</td>
              <td class="fit">
                {{item.iletisim_Tel}}
                <!-- <div v-if="item.temsil_TemsiliyetTuru && item.temsil_TemsiliyetTuru != 0">
                  {{getOptionWithParams(item.temsil_TemsiliyetTuru, "temsiliyetTur")}} ({{item.temsil_AdiSoyadi}})
                </div>
                <div v-if="!item.temsil_TemsiliyetTuru || item.temsil_TemsiliyetTuru == 0">
                  <span v-if="item.uyelikIstifaTarihi">İstifa</span>
                  <span v-if="!item.uyelikIstifaTarihi">Kendisi</span>
                </div> -->
              </td>
              <td class="fit" v-if="$store.state.auth.user.mbId === 0">{{ item.mbName }}</td>
              <td class="fit text-right">
                  <Can I="delete" a="/uye/Uye">
                      <button class="btn btn-sm btn-outline-secondary" @click.stop="showDeleteModal(item)">
                          <font-awesome-icon icon="trash-alt" size="lg"></font-awesome-icon>
                      </button>
                  </Can>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row" v-if="$store.state.uye.uye.liste.length > 0 && !showError">
        <div class="col">
          <i class="text-secondary">{{ $store.state.uye.uye.sayfalama.totalItems }} kayıttan {{ ((form.pageNum - 1) * form.pageSize) + 1 }} - {{ form.pageNum * form.pageSize }} arası gösterilmektedir</i>
        </div>
        <div class="col">
          <div class="row">
            <div class="col d-flex justify-content-end">
              <nav>
                <paginate v-if="$store.state.uye.uye.liste.length"
                          :page-count="$store.state.uye.uye.sayfalama.totalPages"
                          :click-handler="changePage"
                          :prev-text="'Önceki'"
                          :next-text="'Sonraki'"
                          :active-class="'active'"
                          :container-class="'pagination'"
                          v-model="form.pageNum">
                </paginate>
              </nav>
            </div>
            <div class="col-2">
              <select class="form-control" v-model="form.pageSize" @change="changeSize">
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="alert alert-danger text-center" v-if="showError">{{ errorMessage }}</div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import {required} from "vuelidate/lib/validators";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/tr';
export default {
  components: {
      DatePicker
  },
  data() {
    return {
      prevRoute:null,
      errorMessage:'',
      showError: false,
      mblist:[],
      uyelikTurListe:[],
      overlay: false,
      form: {
        mbId:this.$store.state.auth.user.mbId || 0,
        mbMemberId:"",
        adSoyad:"",
        uyelikTuru:0,
        uyelikDurumu:"DEVAMEDYR",
        tcKimlikNo:"",
        uyelikTarihiBaslangic:"",
        uyelikTarihiBaslangicUI:"",
        uyelikTarihiBitis:"",
        uyelikTarihiBitisUI:"",
        yetkiBelgesiBaslangic:"",
        yetkiBelgesiBaslangicUI:"",
        yetkiBelgesiBitis:"",
        yetkiBelgesiBitisUI:"",
        pageNum: 1,
        pageSize: 25,
        orderType: 0
      },
      fileUploadForm: {
        link:"",
        fileName:""
      },
      log: {
        liste: [],
        sayfalama: {}
      },
      logForm:{
        mbId:this.$store.state.auth.user.mbId,
        parameter1:"",
        userName:"",
        pageNum: 1,
        pageSize: 25
      }
    }
  },
  validations: {
    fileUploadForm:{
      link: {
        required
      },
      fileName: {
        required
      }
    }
  },
  methods: {
    ...mapActions('general', ['showModal', 'errorHandling', 'fileUpload']),
    ...mapActions('uye', ['searchUye','getMBList', 'getMBUyeTurleri','deleteUye','importList', "getLog"]),
    clear() {
      this.$store.state.uye.searchList = false;
      this.$store.state.uye.uye = Object.assign({}, {
        liste: [],
        sayfalama: {}
      });
      this.form = Object.assign({}, {
        mbId:this.$store.state.auth.user.mbId || 0,
        mbMemberId:"",
        adSoyad:"",
        uyelikTuru:0,
        uyelikDurumu:"DEVAMEDYR",
        tcKimlikNo:"",
        uyelikTarihiBaslangic:"",
        uyelikTarihiBaslangicUI:"",
        uyelikTarihiBitis:"",
        uyelikTarihiBitisUI:"",
        yetkiBelgesiBaslangic:"",
        yetkiBelgesiBaslangicUI:"",
        yetkiBelgesiBitis:"",
        yetkiBelgesiBitisUI:"",
        pageNum: 1,
        pageSize: 25,
        orderType: 0
      });
      this.$store.state.uye.duplicateForm = Object.assign({}, this.form);
      this.showError = false;
    },
    changeSize() {
      this.list();
    },
    changePage(pageNumber) {
      this.form.pageNum = pageNumber;
      this.list();
    },
    search(){
      this.form.pageNum = 1;
      this.list();
    },
    list() {
      this.$store.state.uye.uye.liste = [];

      if (this.isEmptyFilterForm()) {
        this.showError = true;
        this.errorMessage = this.getMessage(140);
        return;
      }
      this.$store.state.uye.duplicateForm = Object.assign({}, this.form);
      this.$store.state.general.showOverlay = true;
      this.showError = false;

      let data = Object.assign({}, this.form);
      data.mbId = data.mbId || 0;
      data.uyelikTuru = data.uyelikTuru || 0;

      data.uyelikTarihiBaslangic = this.convertSubmitDateFormat(data.uyelikTarihiBaslangicUI) || null;
      data.uyelikTarihiBitis = this.convertSubmitDateFormat(data.uyelikTarihiBitisUI) || null;
      data.yetkiBelgesiBaslangic = this.convertSubmitDateFormat(data.yetkiBelgesiBaslangicUI) || null;
      data.yetkiBelgesiBitis = this.convertSubmitDateFormat(data.yetkiBelgesiBitisUI) || null;

      this.searchUye(data).then(res => {
        this.$store.state.general.showOverlay = false;
        if(res.errorCode !== 0 && res.errorCode !== 118){
          this.errorHandling(res);
          return;
        }
        if ((res.data && res.data.liste.length === 0) || !res.data) {
          this.showError = true;
          this.errorMessage = this.getMessage(118);
          this.$store.state.uye.searchList = true;
        }else{
          this.$store.state.uye.searchList = true;
          this.showError = false;
          this.errorMessage = "";
          this.$store.state.uye.uye.liste.forEach(element => {
            let mbCheck = this.mblist.filter(x => x.id === element.mbId);
            if(mbCheck.length > 0)
              element.mbName = mbCheck[0].name;
          });
        }
      }).catch(() => {
        this.$store.state.general.showOverlay = false;
      });
    },
    showDeleteModal(item) {
      this.$store.state.uye.removeItem = item;
      this.$bvModal.show('modal-uye-delete');
    },
    remove() {
      this.$store.state.general.showOverlay = true;
      this.deleteUye(this.$store.state.uye.removeItem.recordId).then((res) => {
        this.$store.state.general.showOverlay = false;
        this.$bvModal.hide('modal-uye-delete');
        if(res.errorCode == 0){
          this.list();
        }else{
          this.errorHandling(res);
        }
      }).catch((err) => {
        this.showModal({title: 'Hata!', message: err, type: 'danger'});
        this.$store.state.general.showOverlay = false;
      });
    },
    getMBListOptions(){
      if(this.$store.state.auth.user.mbId !== 0)
        return;

      this.$store.state.general.showOverlay = true;
      this.getMBList().then(res => {
        if(res.errorCode == 0){
            this.mblist = res.data;
        }else{
            this.errorHandling(res);
        }
        this.$store.state.general.showOverlay = false;
      });
    },
    getMBUyeTurleriOptions(){
      this.uyelikTurListe = [];
      this.$store.state.general.showOverlay = true;
      this.getMBUyeTurleri(parseInt(this.$store.state.auth.user.mbId)).then(res => {
        if(res.errorCode == 0){
          this.uyelikTurListe = res.data;
        }
        this.$store.state.general.showOverlay = false;
      });
    },
    addFileUploadModal(){
      this.$v.fileUploadForm.$reset();
      this.fileUploadForm = {
        link:"",
        fileName:""
      }
      this.$bvModal.show('modal-file-upload');
    },
    isEmptyFilterForm() {
      this.formTrimCheck(this.form);
      return (this.$store.state.auth.user.mbId !== 0 || this.form.mbId === 0)
        && this.form.uyelikTuru === null 
        && this.form.uyelikDurumu === ""
        && this.form.adSoyad === ""
        && this.form.tcKimlikNo === ""
        && this.form.mbMemberId === ''
        && !this.form.uyelikTarihiBaslangicUI
        && !this.form.uyelikTarihiBitisUI === ''
        && !this.form.yetkiBelgesiBaslangicUI === ''
        && !this.form.yetkiBelgesiBitisUI === '';
    },
    onChangeFileUpload() {
      if(this.$refs.file.files.length === 0){
        return;
      }
      if (!this.$refs.file.files[0].name.match(/.(xlsx|xls)$/i)) {
        this.showModal({title: 'Hata!', message: this.getMessage(51), type: 'danger'});
        this.$refs.file.files = null;
      } else {
        this.fileUploadForm = {
          link:"",
          fileName:this.$refs.file.files[0].name
        }
      }
    },
    fileUploader(onlyCheck = true){
      if(this.fileUploadForm.link !== ""){
        this.importFile(onlyCheck);
      }else{
        const formData = new FormData();
        formData.append('file', this.$refs.file.files[0]);
        this.$store.state.general.showOverlay = true;
        
        this.fileUpload(formData).then((res) => {
          if(res.errorCode == 0){
            this.fileUploadForm.link = res.data.fileRepresenter;
            this.$store.state.general.showOverlay = false;
            this.importFile(onlyCheck);
          }else{
            this.$store.state.general.showOverlay = false;
            this.errorHandling(res);
          }
        }).catch((err) => {
          this.showModal({title: 'Hata!', message: err, type: 'danger'});
          this.$store.state.general.showOverlay = false;
        });
      }  
    },
    importFile(onlyCheck){
      let data = {
        mbId: this.$store.state.auth.user.mbId,
        fileName: this.fileUploadForm.fileName,
        link: this.fileUploadForm.link,
        onlyCheck:onlyCheck
      }
      this.$store.state.general.showOverlay = true;
      this.importList(data).then(res => {
        if(res.errorCode == 0){
          this.$store.state.general.showOverlay = false;
          this.showModal({title: 'İşlem Başarılı', message: this.getMessage(53), type: 'success'});
        }else{
          this.errorHandling(res);
        }
      });
    },
    getLogModal(){
      this.log.liste = [];
      this.getLog(this.logForm).then(res => {
        this.$store.state.general.showOverlay = false;
        if(res.errorCode !== 0 && res.errorCode !== 118){
          this.errorHandling(res);
          return;
        }
        if ((res.data && res.data.liste.length === 0) || !res.data) {
          this.showError = true;
          this.errorMessage = this.getMessage(118);
        }else{
          this.log = res.data;

          this.showError = false;
          this.errorMessage = "";
        }
      }).catch(() => {
        this.$store.state.general.showOverlay = false;
      });
    },
    changeLogPage(pageNumber) {
      this.logForm.pageNum = pageNumber;
      this.getLogModal();
    },
    changeLogSize() {
      this.logForm.pageNum = 1;
      this.getLogModal();
    },
    clearLogForm(){
      this.log.liste = [];
      this.logForm.userName = "";
      this.logForm.parameter1 = "";
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  created() {
    this.getMBListOptions();
    this.getMBUyeTurleriOptions();
  },
  watch: {
    prevRoute(nw) {
      if (nw.name === 'uye-detay' || nw.name === 'uye-detay-id') {
        if (Object.keys(this.$store.state.uye.duplicateForm).length > 0) {
          this.form = Object.assign({}, this.$store.state.uye.duplicateForm);
          if(this.$store.state.uye.searchList){
            this.list();
          }
        }
      } else {
        this.clear();
      }
    }
  },
  computed: {
    ...mapGetters('general', ['getMessage', 'getOptionWithParams', 'convertSubmitDateFormat', 'getFileLink', 'getLogAction', 'formTrimCheck'])
  }
};
</script>